(function($) {

    'use strict';

    var init = function() {
        closePopup();
        focusClose();
        echapClose();
        clickOutsideClose();
    };
    
    var closePopup = function(){
        $('#eventPopup-close-button > svg').on('click', function(){
            $('.eventPopup__overlay').hide();
        });

        $('#eventPopup-close-button').on('click', function(){
            $('.eventPopup__overlay').hide();
        });
    };

    var focusClose = function(){
        $('#eventPopup-close-button').focus();
    };

    var echapClose = function(){
        $(document).on('keydown', function(event) {
            if (event.key === 'Escape') {
                $('.eventPopup__overlay').hide();
            }
        });
    };

    var clickOutsideClose = function(){
        $('.eventPopup__wrapper').on('click', function(event) {
            if (event.target === this) {
                $('.eventPopup__overlay').hide();
            }
        });
    };

    $(document).ready(function() {
        if($('#eventPopup').length){
            init();
        }
    });

})(jQuery);